export default "__VITE_ASSET__J8$y6Wlt__"